export const ConfigPrivacy = () => {
    return (
        <div>
            <h1>Privacy Configuration</h1>
        </div>
    )
}